import { Box, Dialog, DialogContent, TextField, Typography } from "@mui/material"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import dayjs from "dayjs"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { driverAttendApiNm, holidayColNm } from "./constant"
import { addIdForDataGrid } from "utils"
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand"
import { holidayColumns } from "./columns"
import { grey } from "@mui/material/colors"
import SaveButton from "components/buttons/SaveButton"
import { alertConfirmDelete, alertError } from "components/Alert"

const initDialogData = {
  HdayDte: dayjs(),
  HdayNm: "",
  Dscp: "",
}

let lastFilter = null
const HolidayDailog = ({ initMonnth, dialogOpen, setDialogOpen, onFinish }) => {

  const { ax } = useContext(GlobalStateContext)
  const [dialogData, setDialogData] = useState(initDialogData)
  const [curMonth, setCurMonth] = useState(dayjs())
  const [dataTable, setDataTable] = useState([])

  const textFieldProps = useCallback((name) => ({
    size: "small",
    label: holidayColNm[name],
    value: dialogData[name],
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData])

  const getData = useCallback((month) => {
    const postData = {
      HdayDteSt: dayjs(month).format("YYYY-MM-01"),
      HdayDteEn: dayjs(month).endOf("month").format("YYYY-MM-DD")
    }
    ax.post(driverAttendApiNm.getHoliday, postData).then(value => {
      if (value.data) {
        setDataTable(addIdForDataGrid(value.data, "HdayDte"))
        lastFilter = postData
      }
    })
  }, [ax])

  const handleDatePickerKeyUp = useCallback((e) => {
    if (e.key === "ArrowUp") {
      setCurMonth(o => {
        const newData = o.add(-1, "month")
        getData(newData)
        return newData
      })
    } else if (e.key === "ArrowDown") {
      setCurMonth(o => {
        const newData = o.add(1, "month")
        getData(newData)
        return newData
      })
    }
  }, [getData])

  const handleEditCommit = useCallback(({ id, field, value }) => {
   
    let realValue = value
    if(field === "HdayDte"){
      realValue = dayjs(value).format("YYYY-MM-DD")
    }
    const postData = {
      HdayDte: dayjs(id).format("YYYY-MM-DD"),
      ColValues: {
        [field]: realValue
      },
    }
    ax.post(driverAttendApiNm.updateHolidayCols, postData, false).then(value => {
      if (value.data) {
        setDataTable(o=>{
          const newData = o.map(row => {
            if (row.HdayDte === id) {
              return { ...row, 
                id: field === "HdayDte" ?value: row.id,
                [field]: realValue 
              }
            }
            return row
          })
          return addIdForDataGrid(newData, "HdayDte")
        })
      }
    })
  }, [ax])

  const handleSearchDatePickerChnage = useCallback((newValue) => {
    setCurMonth(newValue)
    if (newValue) {
      getData(newValue)
    }
  }, [getData])
  
  const handleSave = useCallback(() => {
    if(!dialogData.HdayDte){
      alertError("กรุณาระบุวันที่")
      return
    }

    const postData = {
      ...dialogData,
      HdayDte: dayjs(dialogData.HdayDte).format("YYYY-MM-DD"),
      getArgs: lastFilter
    }
    ax.post(driverAttendApiNm.insertHoliday, postData).then(value=>{
      if(value.data){
        setDataTable(addIdForDataGrid(value.data, "HdayDte"))
      }
    })
  }, [ax, dialogData])


  const handleCellClick = useCallback(({field, id}) => {
    if(field === "Delete"){
      alertConfirmDelete(()=>{
        const postData = {
          HdayDte: dayjs(id).format("YYYY-MM-DD"),
          getArgs: lastFilter
        }
        ax.post(driverAttendApiNm.deleteHoliday, postData).then(value => {
          if (value.data) {
            setDataTable(addIdForDataGrid(value.data, "HdayDte"))
          }
        }) 
      })
    }
  }, [ax])

  useEffect(() => {
    if (dialogOpen) {
      if (initMonnth) {
        setCurMonth(initMonnth)
      }
      getData(initMonnth || dayjs())
    }
  }, [dialogOpen, ax, initMonnth, getData])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='lg'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="การจัดการวันหยุด"
        onDeleteClick={null}
      />
      <DialogContent>
        <BoxFR pt={2} sx={{alignItems: "stretch"}} >
          <BoxFC sx={{ gap:1, border: `1px solid ${grey[300]}`, borderRadius: 2, p: 2 }}>
            <Typography variant="h6" sx={{mb: 1}}>เพิ่มข้อมูลวันหยุด</Typography>
            <DesktopDatePicker label={holidayColNm.HdayDte} value={dialogData.HdayDte}
              inputFormat= "DD/MM/YYYY"
              mask="__/__/____"
              renderInput={(params) => <TextField {...params} sx={{ width: 200 }} size="small" />}
              onChange={(newValue) => setDialogData(o => ({ ...o, HdayDte: newValue }))} />
            <TextField {...textFieldProps("HdayNm")} />
            <TextField {...textFieldProps("Dscp")} />
            <SaveButton onClick={handleSave} />
          </BoxFC>
          <BoxFC flex={1} sx={{gap: 1}}>
            <DesktopDatePicker label="เดือน" value={curMonth}
              openTo="month"
              views={["year", "month"]}
              renderInput={(params) => <TextField {...params} sx={{ width: 200 }} size="small" 
              onKeyUp={handleDatePickerKeyUp} />} 
              onChange={handleSearchDatePickerChnage}/>
            <Box height={300}>
              <DataGridCellExpand
                hideFooter
                hideToolbar
                rows={dataTable}
                columns={holidayColumns}
                onCellEditCommit={handleEditCommit}
                onCellClick={handleCellClick}
              />
            </Box>
          </BoxFC>
        </BoxFR>

      </DialogContent>
      <DialogFooter okText={""}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default React.memo(HolidayDailog)